import React from 'react';
import gridStyles from 'src/assets/style/grid.module.css';
import styles from './InfoColumnLinks.module.css';

interface Link {
  id: number;
  name: string;
  normalisedName: string;
  indexed: boolean;
  infoPageEnabled: boolean;
  aliases: string[];
  image: {
    id: number;
    uris: {
      [key: string]: string;
    };
  };
}

interface Props {
  title: string;
  links: Link[];
  url: (link: Link) => string;
}

export function InfoColumnLinks(props: Props): React.ReactElement | null {
  const { title, links, url } = props;

  const titleNode = title ? <h2 className={styles.title}>{title}</h2> : null;
  const generatedLinks = links.map((link) => {
    const linkUrl = url(link);

    return (
      <li key={link.id} className={styles.item}>
        <a href={linkUrl} className={styles.link}>
          {link.name}
        </a>
      </li>
    );
  });

  if (!generatedLinks || generatedLinks.length === 0) {
    return null;
  }

  return (
    <section className={styles.links}>
      {titleNode}
      <div className={gridStyles['col-xs-12']}>
        <ul className={styles.list}>{generatedLinks}</ul>
      </div>
    </section>
  );
}
